import React, { Component } from 'react';
import { connect } from 'react-redux';
import { pointActions } from '../../store/modules/point';
import PointReferralIssueListWrap from '../../views/point/referralIssue/PointReferralIssueListWrap/PointReferralIssueListWrap';
import { _LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import {
  POINT_REFERRAL_ISSUE_LIST_SEARCH_OPTION_MODEL,
  POINT_REFERRAL_ISSUE_LIST_SORT_OPTION_MODEL,
} from '../../store/modules/point/models';

class PointReferralIssueListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   *  레퍼럴 횟수가 많은 순으로 정렬
   */
  initiate = () => {
    this.getList({
      searchOption: POINT_REFERRAL_ISSUE_LIST_SEARCH_OPTION_MODEL,
      sortOption: POINT_REFERRAL_ISSUE_LIST_SORT_OPTION_MODEL,
      pagination: _LIST_PAGINATION_MODEL,
    });
  };

  /**
   * list 조건에 따라 받아오기
   */
  getList = (data) => {
    const { getPointReferralIssueList, pointReferralIssueList } = this.props;
    const { searchOption, sortOption, pagination } = pointReferralIssueList;

    getPointReferralIssueList({
      searchOption,
      sortOption,
      pagination,
      ...data,
    });
  };

  render() {
    const { setData, pointReferralIssueList } = this.props;

    return (
      <PointReferralIssueListWrap
        setData={setData}
        pointReferralIssueList={pointReferralIssueList}
        getList={this.getList}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    pointReferralIssueList: state.point.pointReferralIssueList,
  };
};

const mapDispatchToProps = {
  setData: pointActions.setData,
  getPointReferralIssueList: pointActions.getPointReferralIssueList,
};

export default connect(mapStateToProps, mapDispatchToProps)(PointReferralIssueListContainer);
